import React from 'react'
import { FilterParam, FilterName } from '../FilterBar.types'
import { GenericFilterDropdown } from './GenericFilterDropdown'

interface UserRoleFilterDropdownProps {
  isNested?: boolean
}

export const UserRoleFilterDropdown: React.FC<UserRoleFilterDropdownProps> = ({
  isNested,
}) => {
  return (
    <GenericFilterDropdown
      filterParam={FilterParam.USER_ROLE}
      filterName={FilterName.USER_ROLE}
      valueKey="userRoles"
      isNested={isNested}
    />
  )
}
